import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getRoomContext } from 'middleware/analytics/selectors';
import { getUserCountryCode } from 'modules/meta/selectors';
import { showRoomDetailsOverlay } from 'modules/overlay/actions';
import { getOptimizedRoomsConfig, getSearchParameters } from 'modules/sapiSearch/selectors';
import { getNumberOfNights } from 'utils/offers';
import { Card } from '@daedalus/atlas/Card';
import { ContentWrapper } from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { roomsToConfigurationObject } from '@daedalus/core/src/room/business/roomConfiguration';
import { RoomInfo } from '@daedalus/shared/src/accommodation/RoomInfo';
import { FrozenRoomOffer } from '../../FrozenRoomOffer';
import { RoomOffersList } from '../../RoomOffersList/RoomOffersList';
import { RoomCardVariant } from '../../RoomVariant/RoomCardVariant';
import { RoomDetailsMountComponent } from '../constants';
import { RoomCardGallery } from '../RoomCardGallery';
import type { RoomCardPropsType } from '../types';
const _exp = /*#__PURE__*/() => Flex.Column;
const RoomCardContentWrapper = /*#__PURE__*/styled(_exp())({
  name: "RoomCardContentWrapper",
  class: "rsrbapp",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => Flex.Column;
const FixedColumnWrapper = /*#__PURE__*/styled(_exp2())({
  name: "FixedColumnWrapper",
  class: "f15yy2ej",
  propsAsIs: true
});
export const RoomCardDesktop = memo(({
  hotelId,
  room,
  variant,
  isFrozen
}: RoomCardPropsType) => {
  const dispatch = useDispatch();
  const onOpenRoomDetailsOverlay = () => {
    dispatch(showRoomDetailsOverlay({
      roomId: room.id,
      hotelId
    }));
  };
  const roomContext = useSelector(state => getRoomContext(state, room.id));
  const rooms = useSelector(state => getOptimizedRoomsConfig(state, hotelId));
  const {
    checkIn,
    checkOut
  } = useSelector(getSearchParameters) || {};
  const userCountry = useSelector(getUserCountryCode);
  const isDetailsLinkVisible = room.description?.length > 0 || room.amenities?.length > 0 || room.images?.length > 0;
  const numberOfNights = getNumberOfNights(checkIn, checkOut);
  const {
    numberOfAdults,
    numberOfChildren,
    numberOfRooms
  } = roomsToConfigurationObject(rooms);
  return <RoomCardVariant variant={variant}>
        <ContentWrapper padding="s600">
          <Flex.Row alignItems="flex-start" gap="s600">
            <FixedColumnWrapper gap="s500">
              <RoomCardGallery onOpenRoomDetailsOverlay={onOpenRoomDetailsOverlay} room={room} />
              <RoomInfo room={room} onOpenRoomDetailsOverlay={onOpenRoomDetailsOverlay} isTruncatedLongName isDetailsLinkVisible={isDetailsLinkVisible} userCountry={userCountry} />
            </FixedColumnWrapper>
            <RoomCardContentWrapper gap="s500">
              <Text variant="titleS">
                <FormattedMessageWrapper id="accommodationPageDesktop.roomCardTitle" defaultMessage="Prices for {numberOfNights, plural, one {1 night} other {# nights}} · {numberOfRooms, plural, one {1 room} other {# rooms}} · {numberOfAdults, plural, one {1 adult} other {# adults}}{numberOfChildren, plural, =0 {} one {, 1 child} other {, # children}}:" values={{
              numberOfRooms,
              numberOfChildren,
              numberOfAdults,
              numberOfNights
            }} />
              </Text>
              <Card borderColorPath="border.neutral.c100" borderRadius="lg">
                <ContentWrapper padding="s500">
                  {isFrozen ? <FrozenRoomOffer hotelId={hotelId} room={room} roomContext={roomContext} /> : <RoomOffersList hotelId={hotelId} room={room} component={RoomDetailsMountComponent.HotelViewRoomsSection} roomContext={roomContext} />}
                </ContentWrapper>
              </Card>
            </RoomCardContentWrapper>
          </Flex.Row>
        </ContentWrapper>
      </RoomCardVariant>;
});
RoomCardDesktop.displayName = 'RoomCardDesktop';

require("./RoomCardDesktop.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomCardDesktop.tsx");